import PlanApi from '@/components/Api/PlanApi.js'
import Api from '@/components/Api/index.js'
import Bus from '@/assets/utils/bus.js'
export function getPlanInfo(planId, budgetMainId) {
  if(planId){
    new PlanApi('plan').planDetail({planId:planId,budgetMainId:budgetMainId}).then(res => {
      if (res.status == 200) {
        Bus.$emit('changePlanInfo', res.data)
      }else{
        this.$message({type:"error",message:res.statusText})
      }
    })  
  }
}
export function refresh(flag,planId, budgetMainId,type) {
  if(flag.budgetMainId&&(flag.addCitySize>0||flag.budgetMainId!=budgetMainId)){
    getPlanInfo(planId,flag.budgetMainId)
  }else{
    getBudgetInfo(budgetMainId,type)
  }
}
export function getBudgetInfo(budgetMainId,refresh) {
  if(budgetMainId){
    new Api('plan').budgetList({budgetMainId:budgetMainId}).then(res => {
      if (res.status == 200) {
        Bus.$emit('changeBudgetInfo', res.data,refresh)
      }else{
        this.$message({type:"error",message:res.statusText})
      }
    })
  }
}
